// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"258cb058","61":"2d6e1efe","90":"8248d84c","295":"73b8b4fb","361":"b1e02fe4","470":"fa48c0d4","538":"917b90fc","561":"f3a00c19","600":"5f2a99d3","719":"efef7733","826":"2317965f","971":"5f3f9a8f"}[chunkId] + ".chunk.js";
};